import axios from 'axios';

const BACKEND_API = process.env.VUE_APP_BCOM_BACKEND_API + '/api/message/';

class EmailService {
  send(name, email, subject, phone, company, textMessage) {
    //const json = JSON.stringify({ answer: 42 });
    return axios.post(BACKEND_API + 'send', {
        name: name,
        email: email,
        subject: subject,
        phone: phone,
        company: company,
        text: textMessage
    }, {
                 headers : {
                     'Content-Type': 'application/json',
                     'Access-Control-Allow-Origin': '*',
                     'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,OPTIONS',
                     'Access-Control-Allow-Headers': 'accept, origin, authorization, content-type, x-requested-with'
                 }
             });
  }
}

export default new EmailService();